import React, {useState, useEffect} from "react";
import BackButton from "components/Button/BackButton";
import SaveButton from "components/Button/SaveButton";
import DeleteButton from "components/Button/DeleteButton";
import useFetch from "utils/hooks/useFetch";
import { useNavigate } from "react-router-dom";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, EmptyString, FormTypeAdd, FormTypeEdit } from "utils/Constant";
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import { ApiCheckIsAdmin, ApiCreateCompany, ApiDeleteCompany, ApiDeleteLocation, ApiGetCompanyById, ApiGetLocation, ApiInsertLocation, ApiUpdateCompany, ApiUpdateLocation } from "utils/constants/api";
import { GetStatus } from "utils/helpers";
import moment from "moment";
import UnDeleteButton from "components/Button/UnDeleteButton";

export default function CompanyForm(){
    let navigate = useNavigate()

    const{ fetch: createCompany } = useFetch(ApiCreateCompany)
    const{ fetch: updateCompany } = useFetch(ApiUpdateCompany)
    const{ fetch: deleteCompany } = useFetch(ApiDeleteCompany)
    const{ fetch: getCompanyById } = useFetch(ApiGetCompanyById)

    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")
    let paramCompanyId = queryString.get("companyId")

    const [companyId, setCompanyId] = useState(EmptyString)
    const [companyName, setCompanyName] = useState(EmptyString)
    const [npwp, setNpwp] = useState(EmptyString)
    const [address, setAddress] = useState(EmptyString)
    const [phone, setPhone] = useState(EmptyString)
    const [bankName, setBankName] = useState(EmptyString)
    const [accountNumber, setAccountNumber] = useState(EmptyString)
    const [city, setCity] = useState(EmptyString)
    const [province, setProvince] = useState(EmptyString)
    const [status, setStatus] = useState(EmptyString)
    const [createDate, setCreateDate] = useState(EmptyString)
    const [updateDate, setUpdateDate] = useState(EmptyString)
    const [updateBy, setUpdateBy] = useState(EmptyString)

    const [errCompanyId, setErrCompanyId] = useState(false)
    const [errCompanyName, setErrCompanyName] = useState(false)
    const [errNpwp, setErrNpwp] = useState(false)
    const [errAddress, setErrAddress] = useState(false)
    const [errPhone, setErrPhone] = useState(false)
    const [errBankName, setErrBankName] = useState(false)
    const [errAccountNumber, setErrAccountNumber] = useState(false)
    const [errCity, setErrCity] = useState(false)
    const [errProvince, setErrProvince] = useState(false)

    const npwpChange = (e) => { setNpwp(e.target.value) }
    const companyNameChange = (e) => { setCompanyName(e.target.value) }
    const addressChange = (e) => { setAddress(e.target.value) }
    const phoneChange = (e) => { setPhone(e.target.value) }
    const bankNameChange = (e) => { setBankName(e.target.value) }
    const accountNumberChange = (e) => { setAccountNumber(e.target.value) }
    const cityChange = (e) => { setCity(e.target.value) }
    const provinceChange = (e) => { setProvince(e.target.value) }

    const saveBtnClick = () => {
        if (fFormValidation()){
            setConfirmationModal({ isOpen: true, data: { onSuccess: async () => { 
                setConfirmationModal({ isOpen: false })
                setLoading({isOpen: true})

                if(formType === FormTypeAdd){
                    fCreateCompany().then(() => {
                        setLoading({isOpen: false})
                    })
                }else{
                    fUpdateCompany().then(() => {
                        setLoading({isOpen: false})
                    })
                }
            }}})
        }
    }
    const deleteBtnClick = () => {
        setConfirmationModal({ isOpen: true, data: { onSuccess: async () => { 
            setConfirmationModal({ isOpen: false })
            setLoading({isOpen: true})

            let stat

            if (status === 1){
                stat = "2"
            }else{
                stat = "1"
            }

            fDeleteCompany(paramCompanyId, stat).then(() => {
                setLoading({isOpen: false})
            })
        }}})
    }
    const backBtnClick = () => {
        //window.location.href = "/company-setting"
        navigate("/company-setting")
    }

    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
	const [loading, setLoading] = useState({isOpen: false})
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })

    useEffect(() => {
        if(formType === FormTypeEdit){
            setLoading({isOpen: true})
            
            fGetCompany(paramCompanyId).then(() => {
                setLoading({isOpen: false})
            })
        }
    }, [])

    // Function Api Call
    async function fCreateCompany(){
        await createCompany({
            data: {
                companyName: companyName,
                npwp: npwp,
                address: address,
                city: city,
                province: province,
                phone: phone,
                bankName: bankName,
                accountNumber: accountNumber
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ isOpen: true, data: { onSuccess: async () => { navigate("/company-setting") }} })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fUpdateCompany(){ 
        await updateCompany({
            data: {
                companyId: companyId,
                companyName: companyName,
                npwp: npwp,
                address: address,
                city: city,
                province: province,
                phone: phone,
                bankName: bankName,
                accountNumber: accountNumber
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ isOpen: true, data: { onSuccess: async () => { navigate("/company-setting") }} })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fGetCompany(paramCompanyId){
        await getCompanyById({
            data: {
                companyId: String(paramCompanyId)
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                let data = response.data
                setCompanyId(data.companyId)
                setCompanyName(data.companyName)
                setNpwp(data.npwp)
                setAddress(data.address)
                setPhone(data.phone)
                setBankName(data.bankName)
                setAccountNumber(data.accountNumber)
                setCity(data.city)
                setProvince(data.province)
                setStatus(data.status)
                setCreateDate(data.createdDate)
                setUpdateDate(data.updatedDate)
                setUpdateBy(data.updatedBy)
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }  
    async function fDeleteCompany(paramCompanyId, status){
        await deleteCompany({
            data: {
                companyId: paramCompanyId,
                status: status
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ 
                    isOpen: true, 
                    data: {
                        onSuccess: async () => {
                            setSuccessModal({ isOpen: false })
                            navigate("/company-setting")
                        }
                    }
                })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({ isOpen: false })
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({ isOpen: false })
                        }
                    },
                    message: response.message
                })
            }
        })
    }

    // Function
    function fFormValidation(){
        let errorCount = 0

        if (formType === FormTypeEdit){
            if (companyId === null || companyId === EmptyString){
                errorCount++
                setErrCompanyId(true)
            }else{
                setErrCompanyId(false)
            }
        }
        
        if (companyName === null || companyName === EmptyString){
            errorCount++
            setErrCompanyName(true)
        }else{
            setErrCompanyName(false)
        }
        if (npwp === null || npwp === EmptyString){
            errorCount++
            setErrNpwp(true)
        }else{
            setErrNpwp(false)
        }
        if (address === null || address === EmptyString){
            errorCount++
            setErrAddress(true)
        }else{
            setErrAddress(false)
        }
        if (city === null || city === EmptyString){
            errorCount++
            setErrCity(true)
        }else{
            setErrCity(false)
        }
        if (province === null || province === EmptyString){
            errorCount++
            setErrProvince(true)
        }else{
            setErrProvince(false)
        }
        if (phone === null || phone === EmptyString){
            errorCount++
            setErrPhone(true)
        }else{
            setErrPhone(false)
        }
        if (bankName === null || bankName === EmptyString){
            errorCount++
            setErrBankName(true)
        }else{
            setErrBankName(false)
        }
        if (accountNumber === null || accountNumber === EmptyString){
            errorCount++
            setErrAccountNumber(true)
        }else{
            setErrAccountNumber(false)
        }

        if(errorCount > 0){
            return false
        }else{
            return true
        }
    }
    
    return(
        <div className="flex flex-col gap-2">
            <div className="flex justify-between">
                <span className="font-semibold text-2xl">Company Detail</span>
                <div className={`flex gap-2 items-end justify-end ${ formType === FormTypeAdd ? 'hidden' : 'block'}`}>
                    <span className="text-sm opacity-60">
                        Status : {GetStatus(status)} | Created Date : {moment(createDate).format("DD MMM yyyy")} | Last Updated : {moment(updateDate).format("DD MMM yyyy")} | Updated By : {updateBy}
                    </span>
                </div>
            </div>
            <hr />

            

            <div className="mt-5 flex flex-col gap-3">
                {/* Company Id */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Company Id</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={companyId} disabled={true} />
                        </div>
                    </div>
                    <div className={`flex items-center ${errCompanyId ? 'block' : 'hidden'}`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Company Id is required!</span>
                    </div>
                </div>

                {/* Company Name */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Company Name</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={companyName} onChange={companyNameChange} maxLength={30} />
                        </div>
                    </div>
                    <div className={`flex items-center ${errCompanyName ? 'block' : 'hidden'}`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Company Name is required!</span>
                    </div>
                </div>

                {/* NPWP */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>NPWP</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={npwp} onChange={npwpChange} maxLength={20} />
                        </div>
                    </div>
                    <div className={`flex items-center ${errNpwp ? 'block' : 'hidden'}`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">NPWP is required!</span>
                    </div>
                </div>

                {/* Address */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-start">
                        <div className="w-48 pt-2">
                            <span>Address</span>
                        </div>
                        <div className="px-4 pt-2 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <textarea className="input" value={address} onChange={addressChange} maxLength={40} />
                        </div>
                    </div>
                    <div className={`flex items-center ${ errAddress ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Address is required!</span>
                    </div>
                </div>

                {/* City */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>City</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={city} onChange={cityChange} maxLength={40} />
                        </div>
                    </div>
                    <div className={`flex items-center ${ errCity ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">City is required!</span>
                    </div>
                </div>

                {/* Province */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Province</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={province} onChange={provinceChange} maxLength={40} />
                        </div>
                    </div>
                    <div className={`flex items-center ${ errProvince ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Province is required!</span>
                    </div>
                </div>

                {/* Phone */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Phone</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={ phone } onChange={phoneChange} maxLength={20} />
                        </div>
                    </div>
                    <div className={`flex flex-wrap items-center ${ errPhone ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Phone is required!</span>
                    </div>
                </div>

                {/* Bank Name */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Bank Name</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={ bankName } onChange={bankNameChange} maxLength={20} />
                        </div>
                    </div>
                    <div className={`flex flex-wrap items-center ${ errBankName ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Bank Name is required!</span>
                    </div>
                </div>

                {/* Account Number */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Bank Account Number</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={ accountNumber } onChange={accountNumberChange} maxLength={20} />
                        </div>
                    </div>
                    <div className={`flex flex-wrap items-center ${ errAccountNumber ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Bank Account Number is required!</span>
                    </div>
                </div>
            </div>

            <div className="mt-5 flex justify-end gap-2">
                <SaveButton onClick={saveBtnClick} visible={true} />                
                <DeleteButton onClick={deleteBtnClick} visible={formType === FormTypeEdit ? (status === 1 ? true : false) : false} />
                <UnDeleteButton onClick={deleteBtnClick} visible={formType === FormTypeEdit ? (status === 2 ? true : false) : false} />
                <BackButton onClick={backBtnClick} />
            </div>

            {/* Modal */}
			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
			{loading.isOpen && ( <LoadingModal onClose={() => setLoading({ isOpen: false })} />)}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </div>
    )
}